import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { localOrderCount } from "../../../actions/ldcrActions";
import { useTranslation } from 'react-i18next';
import { DataGrid } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
    containerStyle: { 
        display: "flex", 
        alignItems: "center",
        marginTop: 10
    },
    spanStyle: { 
        display: "inline-block", 
        padding: '0 20px', 
        paddingTop: '5px' 
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    },
    checkboxesStyle: {
        marginBottom: 10, 
        display: 'flex', 
        alignItems: 'center', 
        marginTop: 20,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    },
    checkboxStyleChecked: {
        display: 'flex', 
        alignItems: 'center',
        border: 'solid 1px #ff9800',
        borderRadius: 5,
        padding: '1px 10px',
        marginTop: 10,
        marginRight: 10
    },
    checkboxStyle: {
        display: 'flex', 
        alignItems: 'center',
        border: 'solid 1px #c8c8c8',
        borderRadius: 5,
        padding: '1px 10px',
        marginTop: 10,
        marginRight: 10
    },
    checkboxTextStyleChecked: {
        color: '#ff9800'
    },
    checkboxTextStyle: {
        color: '#c8c8c8'
    }
}));

const moment = require('moment');

function ReportSearch() {
    const {t} = useTranslation('localDeliveryCountReport');
    const classes = useStyles();
    const dispatch = useDispatch();

    const columns = [
        {field: 'id', headerName: t('id'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'partner_shop_name', headerName: t('name'), width: 600, headerAlign: 'center', align: 'center'},
        {field: 'count', headerName: t('count'), width: 200, headerAlign: 'center', align: 'center'}
    ];

    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [list, setList] = useState([]);
    const [disable, setDisable] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false);

    const handleSearch = (dateFrom, dateTo) => {     
        const moment = require('moment');
        const dateFromNum = moment(dateFrom).startOf('day').valueOf();
        const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf());
        const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
        const diffDays = Math.round((dateToNum - dateFromNum) / oneDay);
        if(diffDays < 0) {
            dispatch(showAlertSnackbar({message: t('not_valid_days'), type: 'error'}))
        } else {
            setDisable(true);
            setIsDataLoading(true);
            dispatch(localOrderCount(dateFromNum / 1000, Math.floor(dateToNum / 1000)))
            .then((res) => {
                setList(res);
                setDisable(false);
                setIsDataLoading(false);
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: t('response_error'), type: 'error'}))
                setDisable(false);
                setIsDataLoading(false);
            })
        }
    }

    function handleDateTo(event){
        const dateToTamp = moment(event.target.value).unix();
        const dateFromTamp = moment(dateFrom).unix();
        if (dateToTamp < dateFromTamp)  {
            setDateTo(dateFrom);
            dispatch(showAlertSnackbar({message: t('no_larger_end'), type: 'error'}))
        } else {
            setDateTo(event.target.value);
        }
    }

    function createRows(){
        return list.map((row) => {
            const {partner_shop_id, ...rest} = row
            return {id: partner_shop_id, ...rest}
        })
    }

    return (
        <Box>
            <Grid container className={classes.containerStyle}>
                <TextField 
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateFrom}
                    onChange={(e)=>setDateFrom(e.target.value)}
                />
                <span className={classes.spanStyle}>{t('to')}</span>
                <TextField 
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateTo}
                    onChange={handleDateTo}
                />
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleSearch(dateFrom, dateTo)}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('view')}
                </Button>
            </Grid>
            <div style={{marginTop: 20}}>
                <DataGrid
                    style={{height:500}}
                    loading={isDataLoading}
                    alignItems="center"
                    rows={createRows()}
                    columns={columns}
                    disableColumnFilter 
                    disableColumnMenu
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    isRowSelectable={false}
                />
            </div>
        </Box>
    );
}

export default ReportSearch;